import { createSlice } from '@reduxjs/toolkit'
import { getProvince, getWard } from '../../api/customer/listAddress';

const initialState = {
    options: [],    // tỉnh/thành
    option3: [],    // xã/phường
    loading: false,
    loading3: false,
}

const listAddress = createSlice({
  name: "listAddress",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Tỉnh/thành (cấp 1)
      .addCase(getProvince.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProvince.fulfilled, (state, action) => {
        state.options = action?.payload?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        state.loading = false;
      })
      .addCase(getProvince.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Xã/phường (cấp 2, theo tỉnh)
      .addCase(getWard.pending, (state) => {
        state.loading3 = true;
      })
      .addCase(getWard.fulfilled, (state, action) => {
        state.option3 = action?.payload?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        state.loading3 = false;
      })
      .addCase(getWard.rejected, (state, action) => {
        state.loading3 = false;
        state.error = action.error.message;
      });
  },
});

export default listAddress.reducer
